<div class="bg-th-blue mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-white my-auto pointer" 
        
            [routerLink]="['/carInfo',mdlViolation.get('strUnitID')?.value]">
        
        </i>

        <a class="text-white f18 my-auto dirI d-flex align-items-center">
            
            سوابق خلافی 
            
        </a>

    </div>

</div>

<main class="container-xxl">

    <section class="border border-2 p-2 mt-4 dirI" style="max-height: 85vh;">

        <form class="w-100 row gx-2 gy-3 gy-md-0 p-2">

            <div class="col-12 col-md-10">

                <input type="text" class="w-100 my-3 form-control" placeholder="جستجو کنید...." (keyup)="filter_list($event.target)">

            </div>

            <div class="col-12 col-md-2 d-flex align-items-center">
    
                <button class="btn w-100 px-3 btn-primary" (click)="openModal(false)"> 
                    
                    استعلام خلافی
                
                </button>
        
            </div>

        </form>

        <div class="section">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">
    
                <thead>
        
                    <tr class="">
        
                        <th class="text-center col-1"> # </th>

                        <th class="text-center col-1"> عملیات </th>

                        <th class="text-center col-1"> تاریخ استعلام </th>

                        <th class="text-center col-1"> جمع کل خلافی(ریال) </th>

                    </tr>
                    
                </thead>
    
                <tbody>
    
                    <tr *ngFor="let item of list_Result; let i=index" style="vertical-align: middle;">
    
                        <th class="col-1 text-center"> {{ i + 1 | faNum }} </th>

                        <td class="col-1 text-center"> 

                            <i title="مشاهده جزئیات" (click)="openModal(true,item)" class="fa fa-file-text-o my-2 
                            
                                my-md-0 fa-lg bg-gray p-2 rounded text-success pointer" aria-hidden="true">
                            
                            </i>

                        </td>

                        <td class="col-3 text-center"> {{ item.strFullDate | faNum }} </td>

                        <td class="col-3 text-center"> {{ item.iTotalOffense.toLocaleString() | faNum }} </td>
    
                    </tr>
    
                </tbody>
        
            </table>

        </div>

    </section>

</main>

<div class="modal fade" id="violation-modal" tabindex="-1" aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">
  
      <div class="modal-content p-1">
  
        <div class="modal-header dirI">
  
          <h5 class="modal-title"> 

            <ng-container *ngIf="!bEditMode"> فرم استعلام خلافی </ng-container>
            
            <ng-container *ngIf="bEditMode"> جزئیات خلافی {{mdlViolation.get('strFullName')?.value}} </ng-container>
            
          </h5>
  
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  
        </div>
  
        <!-- استعلام خلافی -->

        <ng-container *ngIf="!bEditMode">

            <div class="modal-body">

                <div [formGroup]="mdlViolation" class="row gx-3 gy-4 p-2 mb-2 justify-content-between rounded">

                    <div class="col-12 d-flex justify-content-center align-items-center">

                        <div class="pelak-container border border-2 ">

                            <div class="pelak-flag">
                                
                                <img src="../../../assets/Img/iran-flag-dark.svg" >
                            
                            </div>

                            <div class="pelak-first">

                                <input type="tel" #first [ngClass]="first.value.trim() != '' ? 'pelak-bigText' : '' "

                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"  

                                    formControlName="pelak1"
                                    
                                    maxlength="2" placeholder="_ _">

                            </div>

                            <div class="pelak-second me-2">

                                <input type="tel" #second 

                                    formControlName="pelak2"
                                
                                    [ngClass]="second.value.trim() != '' ? 'pelak-bigText' : '' " 
                                    
                                    maxlength="1" placeholder="_">

                            </div>

                            <div class="pelak-third me-2">

                                <input type="tel" #third [ngClass]="third.value.trim() != '' ? 'pelak-bigText' : '' "

                                    formControlName="pelak3"
                                
                                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                    
                                    maxlength="3" placeholder="_ _ _">

                            </div>

                            <div class="pelak-fourth">

                                <input type="tel" #fourth [ngClass]="fourth.value.trim() != '' ? 'pelak-bigText' : '' "

                                formControlName="pelak4"
                                
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                
                                maxlength="2" placeholder=" _ _ ">

                            </div>

                        </div>

                    </div>

                    <div class="position-relative col-12 col-md-6">
    
                        <label for="strFamily"> شماره موبایل مالک </label>
    
                        <input dir="ltr" type="text" 

                            maxlength="11"
                        
                            oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                        
                            formControlName="strMobile" class="form-control">
    
                    </div>

                    <div class="position-relative col-12 col-md-6">
    
                        <label for="strFamily"> کد ملی مالک  </label>
    
                        <input dir="ltr" type="text" 

                            maxlength="10"

                            oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                        
                            formControlName="strNationalCode" class="form-control">
    
                    </div>

                </div>

            </div>

            <div class="modal-footer">
                
                <div class="col-12 d-flex justify-content-start">
    
                    <button class="btn px-4 btn-success" >
    
                      استعلام
    
                    </button>
    
                </div>
                
            </div>

        </ng-container>

        <!-- مشاهده جزئیات خلافی -->

        <ng-container *ngIf="bEditMode">

            <div class="modal-body">

                <div class="section">

                    <table class="col-12 table table-striped rounded-3" id="Export_Excel">
            
                        <thead>
                
                            <tr class="">
                
                                <th class="text-center col-1"> # </th>

                                <th class="text-center col-1"> عملیات </th>
        
                                <th class="text-center col-1"> تاریخ استعلام </th>

                                <th class="text-center col-1"> عنوان </th>
                                
                                <th class="text-center col-1"> شرح تخلف </th>
        
                                <th class="text-center col-1"> مبلغ(ریال) </th>

                                <th class="text-center col-1"> وضعیت </th>

                            </tr>
                            
                        </thead>
            
                        <tbody>
            
                            <tr *ngFor="let item of lst_Violations; let i=index" style="vertical-align: middle;">
            
                                <th class="col-1 text-center"> {{ i + 1 | faNum }} </th>

                                <th class="col-1 text-center">

                                    <i title="تصویر"  class="fa fa-image my-2 
                            
                                        my-md-0 fa-lg bg-gray p-2 rounded
                                        
                                        text-secondary pointer" aria-hidden="true">
                                
                                    </i>
                                    
                                </th>
        
                                <td class="col-2 text-center"> {{ item.strFullDate | faNum }} </td>

                                <td class="col-3 text-center"> {{ item.strTitle | faNum }} </td>

                                <td class="col-3 text-center"> {{ item.strDetail | faNum }} </td>
        
                                <td class="col-2 text-center"> {{ item.iPenalty.toLocaleString() | faNum }} </td>

                                <td class="col-1 text-center"> {{ item.bPaid ? '✅' : '❌'  }} </td>
            
                            </tr>
            
                        </tbody>
                
                    </table>
        
                </div>


            </div>

            <div class="modal-footer"> </div>

        </ng-container>

      </div>
  
    </div>
  
</div>